export default {
  DEBUG_CLOSE_BUTTON: 'frontend.global.operation.debugopenclose',
  DEBUG_OPEN_BUTTON: 'frontend.global.operation.debugopen',
  CONFIRM_BUTTON: 'frontend.global.operation.confirm'
};
